export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[60px] md:pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-primary-100/50 blur-[120px]"></div>
        <div className="absolute -bottom-32 -left-32 w-[400px] h-[400px] rounded-full bg-accent-100/40 blur-[100px]"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="w-full">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-medium mb-5 md:mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>每日更新 · 持续追踪</span>
            </div>

            <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-5xl leading-tight text-foreground-950 mb-3 md:mb-4">
              黑料吃瓜网
              <br />
              <span className="text-primary-600">最新娱乐八卦聚合平台</span>
            </h1>

            <p className="text-base md:text-lg font-heading text-foreground-600 italic mb-4 md:mb-5">
              —— 一手黑料，全网最快，吃瓜群众的聚集地
            </p>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6 md:mb-7 max-w-xl">
              黑料吃瓜网专注娱乐圈、网红圈、明星八卦与热点事件追踪，每日更新全网最新
              <strong>黑料吃瓜网站</strong>与<strong>黑料吃瓜网址</strong>信息。无论你是想找
              <strong>黑料吃瓜网入口</strong>免费观看最新内容，还是通过手机版官网直达，
              这里提供持续更新的<strong>最新地址网址入口</strong>，让你不错过任何一条精彩大瓜。
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-7 md:mb-8">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-timer-flash-line text-accent-600 text-sm"></i>
                </span>
                <div>
                  <p className="text-lg md:text-xl font-bold text-foreground-950">实时追踪</p>
                  <p className="text-xs text-foreground-500">7×24小时更新</p>
                </div>
              </div>
              <div className="w-px h-10 bg-background-200 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-eye-line text-primary-600 text-sm"></i>
                </span>
                <div>
                  <p className="text-lg md:text-xl font-bold text-foreground-950">千万访问</p>
                  <p className="text-xs text-foreground-500">月均活跃用户</p>
                </div>
              </div>
              <div className="w-px h-10 bg-background-200 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-shield-check-line text-secondary-600 text-sm"></i>
                </span>
                <div>
                  <p className="text-lg md:text-xl font-bold text-foreground-950">安全访问</p>
                  <p className="text-xs text-foreground-500">地址持续更新</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-down-circle-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-foreground-200 text-foreground-800 font-medium text-sm rounded-lg hover:border-primary-400 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line text-lg"></i>
                投稿爆料
              </a>
            </div>
          </div>

          <div className="w-full hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-xl overflow-hidden bg-background-200/50">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20collage%20style%20image%20with%20newspaper%20clippings%20magazine%20covers%20and%20social%20media%20feeds%20layered%20together%20warm%20crimson%20and%20amber%20tones%20bold%20typography%20elements%20breaking%20news%20aesthetic%20editorial%20design%20vibe%20with%20soft%20glow%20and%20dramatic%20lighting%20cinematic%20composition&width=1000&height=750&seq=hero-main-visual&orientation=landscape"
                alt="黑料吃瓜网 - 娱乐八卦热点聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/20 to-transparent"></div>
            </div>
          </div>

          <div className="w-full lg:hidden mt-0">
            <div className="relative w-full aspect-[16/9] rounded-xl overflow-hidden bg-background-200/50">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20collage%20style%20image%20with%20newspaper%20clippings%20magazine%20covers%20and%20social%20media%20feeds%20layered%20together%20warm%20crimson%20and%20amber%20tones%20bold%20typography%20elements%20breaking%20news%20aesthetic%20editorial%20design%20vibe%20with%20soft%20glow%20and%20dramatic%20lighting%20cinematic%20composition&width=800&height=450&seq=hero-mobile-visual&orientation=landscape"
                alt="黑料吃瓜网 - 娱乐八卦热点聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}